module.exports = __webpack_public_path__ + "img/dstv-change-package-4.fa0e6d4d.jpg";